
import { NotificationPreferences } from "@/types/notifications";

export const DEFAULT_PREFERENCES: NotificationPreferences = {
  email_notifications: true,
  sms_notifications: false,
  web_push_notifications: false,
  app_notifications: true,
  new_content_notifications: true,
  comment_notifications: false,
  marketing_notifications: false,
  account_notifications: true,
  system_notifications: true
};
